import styled from '@emotion/styled';

export const GanntChartWrap = styled.div`
  position: relative;
  padding-bottom: 17px;
  font-size: 13px;
  background-color: #f1f4f3;
  .chart-container table {
    border-collapse: separate;
    border-spacing: 0;
  }
  .gantt-scroll::-webkit-scrollbar {
    display: none;
  }
  .gantt-header table col,
  .fixed-header-wrapper table col {
    width: 90px;
  }
  th,
  td {
    border: 1px solid #dde0df;
    border-left: none;
    border-bottom: none;
    padding: 8px;
    text-align: center;
    font-size: 13px;
    line-height: 17px;
    vertical-align: middle;
  }
  th {
    z-index: 100;
    position: relative;
  }
  thead th {
    border-top: none;
    background: #f1f4f3;
    font-weight: bold;
  }
`;

export const ChartContainer = styled.div`
  border: 1px solid #dde0df;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  height: 800px;
  table {
    border-collapse: separate;
    border-spacing: 0;
  }
  table tbody tr:first-child td {
    border-top: none;
  }
`;
export const ChartTableHeader = styled.div`
  position: relative;
  z-index: 3;
  background-color: #fff;
  display: table;
  height: 100%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  table {
    table-layout: fixed;
    width: 370px;
    // height: 100%;
    border-bottom: 1px solid #dde0df;
  }
  table thead th {
    position: sticky;
    top: 0px;
    border-bottom: 1px solid #dde0df;
  }
  table thead th.top {
    top: 34px;
  }
`;

export const ChartTableBody = styled.div`
  position: relative;
  background-color: #fff;

  .gantt-header,
  .fixed-header-wrapper {
    table {
      table-layout: fixed;
      width: 90px;
    }
    col {
      width: 90px;
    }
  }

  .gantt-header {
    display: flex;
    height: calc(100% - 68px);
    box-sizing: border-box;
    position: relative;
    top: 0;
    z-index: 1;
    table td {
      padding: 8px 0;
      background-color: #fff;
    }
  }

  .fixed-header-wrapper {
    position: sticky;
    top: 0;
    height: 68px;
    background-color: #f1f4f3;
    z-index: 2;
    overflow: hidden;
    border-bottom: 1px solid #dde0df;

    table {
      border-collapse: separate;
      border-spacing: 0;
      height: 100%;
      tr:first-child th {
        border-bottom: 1px solid #dde0df;
      }
      thead th {
        position: static;
        z-index: auto;
      }
    }
  }
`;

export const GanttScroll = styled.div`
  position: absolute;
  top: 67px;
  bottom: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;

  &::-webkit-scrollbar {
    display: none;
  }

  .gantt-bar-layer {
    position: relative;
    height: 68px;
    border-bottom: 1px #dde0df dotted;
  }
  /* .gantt-bar-layer:nth-child(odd){
        background-color: rgba(247, 249, 248, 0.4);
    } */
  .gantt-bar-layer:first-child {
    height: 69px;
  }

  /* 막대 그래프 공통 스타일 */
  .gantt-bar {
    position: absolute;
    display: block;
    height: 14px;
    box-sizing: border-box;
    /* z-index: 2; */
  }

  .gantt-bar > span {
    font-size: 10px;
  }

  .date-box {
    position: absolute;
    top: -2px;
    display: block;
    height: 16px;
    width: 16px;
    text-align: center;
    line-height: 14px;
    color: #fff;
    border-radius: 50%;
    border: none;
    background-color: #1f5e94;
    /* letter-spacing: -1px; */
  }
  .date-start {
    left: -10px;
  }
  .date-end {
    right: -10px;
  }

  /* 막대별 색상 및 텍스트 */
  .plan-bar {
    border: 1px #a0c3e1 solid;
    background-color: #dceaf5;
    top: 14px;
  }
  .actual-bar {
    background-color: #d3d3d3;
    top: 51px;
  }
  .date-text {
    color: black;
    font-weight: normal;
    font-size: 0.9em;
    padding: 0 5px;
  }

  /* 진행률 표시줄 */
  .progress-bar {
    position: absolute;
    top: 40px;
    display: flex;
    border-width: 1px;
    border-style: solid;
    /* border-radius: 14px;
        overflow: hidden; */
    background-color: #fff;
  }
  .progress-bar .progress {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.7;
  }

  .progress-bar.done {
    border-color: #00806a;
  }
  .progress-bar.done span {
    color: #fff;
    background-color: #00806a;
  }

  .progress-bar.warning {
    border-color: #ffcb0b;
  }
  .progress-bar.warning span {
    color: #fff;
    background-color: #fdcf2b;
  }

  .progress-bar.delay {
    /* border-color: #FDA293; */
    border-color: #da3f42;
  }
  .progress-bar.delay span {
    /* color: #B32542;
        background-color: #FEE6DB; */
    color: #fff;
    background-color: #da3f42;
  }

  .progress-bar.ing {
    /* border-color: #FDA293; */
    border-color: #2d9bb2;
  }
  .progress-bar.ing span {
    /* color: #B32542;
        background-color: #FEE6DB; */
    color: #fff;
    background-color: #2d9bb2;
  }

  .progress-bar.none {
    border-color: #5b5c5b;
  }
  .progress-bar.none span {
    color: #5b5c5b;
    background: #fff;
  }
  .progress-bar.none span:not(.progress) {
    border: 1px #5b5c5b solid;
    box-sizing: border-box;
  }
  .progress-bar.none .progress {
    width: 100%;
  }

  .final-timeline-indicators {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
  }
  .final-timeline-indicators > div {
    display: flex;
    border-width: 1px;
    position: relative;
  }
  .final-timeline-indicators > div > span {
    display: block;
    position: absolute;
    white-space: nowrap;
    transform: rotate(-90deg);
    left: -22px;
    font-size: 12px;
    font-weight: 600;
    font-family: sans-serif;
  }
  .final-plan-line {
    /* margin-right: 40px; */
    border-style: dashed;
    border-color: #554596;
    color: #554596;
    span {
      top: 132px;
    }
  }
  .final-actual-line {
    border-style: dashed;
    border-color: #ff5c98;
    color: #ff5c98;
    span {
      top: 232px;
    }
  }
  .target-plan-line {
    border-style: dashed;
    border-color: #2d9bb2;
    color: #2d9bb2;
    span {
      top: 32px;
    }
  }
`;

export const HorizontalScrollbar = styled.div`
  position: absolute;
  bottom: 0;
  left: 460px;
  width: calc(100% - 460px);
  overflow-x: scroll;
  overflow-y: hidden;
  z-index: 2;
  height: 16px;
  background-color: #f1f4f3;
  border-top: none;
  border: 1px solid #dde0df;
  margin: 0;
  padding: 0;
  .scrollbar-content {
    width: 1px;
    height: 1px;
  }
`;
